import type { Site } from "@/models/site"

type SiteIdentityFields = Pick<Site, "departmentName" | "name">

export const formatSiteIdentity = (
  site: SiteIdentityFields | null | undefined,
  unknownSiteName: string
): string => {
  if (!site?.name) {
    return unknownSiteName
  }

  return site.departmentName
    ? `${site.name}, ${site.departmentName}`
    : site.name
}
